import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  FileText, 
  Receipt, 
  ShieldAlert, 
  Users 
} from 'lucide-react';
import '../../../assets/styles/customer/layout/ProblemSection.css';

const ProblemSection = () => {
  const problems = [
    {
      id: 1,
      icon: <FileText size={48} strokeWidth={1.5} />,
      title: 'Manual Registers',
      description: 'Updating diaries daily is messy and time-consuming',
      iconColor: '#3e96e7'
    },
    {
      id: 2,
      icon: <Receipt size={48} strokeWidth={1.5} />,
      title: 'Billing Errors',
      description: 'Handwritten bills lead to miscalculations & disputes',
      iconColor: '#ffc107'
    },
    {
      id: 3,
      icon: <ShieldAlert size={48} strokeWidth={1.5} />,
      title: 'Lack of Transparency',
      description: 'No clear logs make it hard to track daily records',
      iconColor: '#4caf50'
    },
    {
      id: 4,
      icon: <Users size={48} strokeWidth={1.5} />,
      title: 'Payment Disputes',
      description: 'Frequent misunderstandings lead to unpaid bills',
      iconColor: '#f44336'
    }
  ];

  return (
    <section className="problem-section">
      <Container>
        
        {/* Section Header */}
        <div className="section-header text-center">
          <h2 className="section-title">The Problem</h2>
          <p className="section-subtitle">
            Say Goodbye to Manual Registers & Billing Errors
          </p>
          <p className="section-description">
            Traditional milk tracking is outdated and error-prone. MilkyWay offers 
            a smarter solution against common pain points.
          </p>
        </div>

        {/* Problem Cards Grid */}
        <Row className="g-4 problem-cards-row">
          {problems.map((problem, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={problem.id}>
              <div 
                className="problem-card"
                style={{ animationDelay: `${index * 0.1}s` }}
              >
                {/* Icon Container */}
                <div 
                  className="problem-icon-container"
                  style={{ backgroundColor: `${problem.iconColor}15` }}
                >
                  <div 
                    className="problem-icon"
                    style={{ color: problem.iconColor }}
                  >
                    {problem.icon}
                  </div>
                </div>

                {/* Card Content */}
                <h3 className="problem-card-title">{problem.title}</h3>
                <p className="problem-card-description">{problem.description}</p>

                {/* Decorative Line */}
                <div 
                  className="problem-card-line"
                  style={{ backgroundColor: problem.iconColor }}
                ></div>
              </div>
            </Col>
          ))}
        </Row>

      </Container>

      {/* Background Decoration */}
      <div className="problem-bg-decoration">
        <div className="decoration-circle circle-1"></div>
        <div className="decoration-circle circle-2"></div>
      </div>
    </section>
  );
};

export default ProblemSection;